// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3943":"0c631773","6384":"31d6cfe0","8139":"cbf2180a"}[chunkId] + ".chunk.css";
};